module.exports = __webpack_public_path__ + "img/lunch_background.3719e7da.png";